import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import {
  resetStore,
  setApplicant,
  setSubmitStatus,
} from "../../store/applicantsSlice";
import { applicantSelector } from "../../store/applicantsSlice";
import {
  proposalSelector,
  setProposal,
  setDaysLeft,
  daysLeftSelector,
  colleaguesSelector,
  setColleagues,
} from "../../store/proposalSlice";
import service from "./helpers/GifService";
import {
  getGeneralInfoProgress,
  getFinancingProgress,
  getSchedulesProgress,
} from "./helpers/GifService/applicantService";
import modules from "./modules/modules";

export default function Applicants() {
  const match = useRouteMatch();
  const applicant = useSelector(applicantSelector);
  const colleagues = useSelector(colleaguesSelector);
  const proposal = useSelector(proposalSelector);
  const daysLeft = useSelector(daysLeftSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetStore());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!!applicant) return;
    service.getApplicant().then((applicant) => {
      dispatch(setApplicant(applicant));
    });
  }, [applicant, dispatch]);

  useEffect(() => {
    if (!!proposal) return;
    service.getProposalData().then((proposal) => {
      dispatch(setProposal(proposal));
    });
  }, [dispatch, proposal]);

  useEffect(() => {
    const getStatus = async () => {
      if (proposal === undefined || proposal === null) return;
      if (applicant === undefined || applicant === null) return;
      const proposalId = proposal.id;
      const applicantId = applicant.id;
      if (applicantId === undefined) return;
      const generalInfo = await getGeneralInfoProgress({
        proposalId,
        applicantId,
      });
      const financing = await getFinancingProgress({ proposalId, applicantId });
      const schedules = await getSchedulesProgress({ proposalId, applicantId });
      //const miscellaneous = await getMiscellaneousProgress({ proposalId });
      const submitStatus = { generalInfo, financing, schedules };
      dispatch(setSubmitStatus(submitStatus));
    };
    getStatus();
  }, [dispatch, proposal, applicant]);

  useEffect(() => {
    const getColleagues = async () => {
      if (!!colleagues && colleagues.length > 0) return;
      if (!proposal?.id) {
        return;
      }
      const fetchedColleagues = await service.getColleagues({
        proposalId: proposal?.id,
      });
      dispatch(setColleagues(fetchedColleagues));
    };
    getColleagues();
  }, [dispatch, proposal, applicant, colleagues]);

  useEffect(() => {
    if (!!daysLeft) return;
    service.getDaysLeft().then((days) => {
      dispatch(setDaysLeft(days));
    });
  }, [dispatch, daysLeft]);

  return (
    <Switch>
      {modules.map(({ path, module: Module }) => (
        <Route
          key={path}
          path={`${match.url}${path}`}
          render={(props) => <Module {...props} baseUrl={match.url} />}
        />
      ))}
      <Redirect to={`${match.url}${modules[0].path}`} />
    </Switch>
  );
}
